import { useState, useRef, useEffect } from "react";
import { MessageCircleQuestion, X, Send, Sparkles } from "lucide-react";
import { SUPPORT_TEL, SUPPORT_PHONE, SUPPORT_WA } from "@/lib/api";

// Gazi Sepet yardımcı asistanı — bilgi tabanı sitenin gerçek özelliklerinden oluşur.
const KB = [
  [["kayıt", "üye", "hesap aç", "kayıt ol"],
   "Kayıt olmak için sağ üstteki 'Kayıt Ol' butonuna basın. İşyeri adı, ad soyad, telefon, e-posta ve şifre girersiniz; hesabınız anında açılır ve size özel 6 haneli kullanıcı numaranız oluşur."],
  [["giriş", "login", "giremiyorum", "şifremi unuttum", "şifre"],
   `Giriş için sağ üstteki 'Giriş' butonunu kullanın. Şifrenizi unuttuysanız giriş ekranındaki 'Şifremi unuttum' bağlantısına tıklayın; sıfırlama bağlantısı e-postanıza gelir. Yine de sorun yaşarsanız bize ${SUPPORT_PHONE} numarasından ulaşabilirsiniz.`],
  [["fiyat", "ücret", "kaç para", "ne kadar", "ödeme planı"],
   "Gazi Sepet tek pakettir: yıllık 6.000 TL. Masa sistemi, QR menü, kurye takibi, Caller ID, kasa-gider takibi, otomatik fiş ve yemek platformu entegrasyonları (Yemeksepeti, Trendyol Go, Migros) hepsi dahildir."],
  [["qr", "qr kod", "menü", "masadan sipariş", "paket"],
   "QR menü iki şekilde çalışır: 1) Masa QR'ı — müşteri masadaki kodu okutup masasına sipariş verir. 2) Paket Sipariş QR'ı — müşteri kodu okutup adres ve telefonunu girer, sipariş eve gider. QR kodları panelin 'Masalar & QR' sayfasından indirebilirsiniz."],
  [["yazıcı", "fiş", "adisyon", "termal"],
   "Yeni sipariş geldiğinde fiş otomatik yazdırılır (58mm veya 80mm termal yazıcı). Fişte işletme adınız, telefonunuz, adresiniz ve QR menü kodunuz basılır. Yazı boyutunu Yazıcı sayfasından Küçük/Normal/Büyük olarak ayarlayabilirsiniz."],
  [["kurye", "paketçi", "teslimat", "kurye uygulaması"],
   "Kurye Takip sayfasından kurye ekleyin; her kuryeye bir kod verilir. Kurye telefonundan /kurye adresine girip koduyla bağlanır, siparişleri haritada görür ve müşteriyi tek dokunuşla arar. Android uygulamasını panelden APK olarak da indirebilir."],
  [["caller", "arama", "telefon geldi", "müşteri tanıma"],
   "Caller ID uygulaması arayan müşteriyi tanır: numarayı girdiğinizde müşterinin adı, adresi ve geçmiş siparişleri ekrana gelir. Paneldeki Caller ID sayfasından bağlantı kodunuzu alıp /caller adresinde kullanın veya Android APK'sını indirin."],
  [["trendyol", "yemeksepeti", "migros", "platform", "entegrasyon"],
   "Platform siparişleri için: 1) Trendyol/Yemeksepeti/Migros partner panelinizden API bilgilerinizi alın, 2) Panelin Entegrasyonlar sayfasındaki karta girip anahtarı açın ve Kaydet'e basın, 3) Karttaki webhook adresini platforma tanıtın. Siparişler otomatik panele düşer. Yıllık aktivasyon için destek hattına yazın."],
  [["kasa", "gider", "ciro", "rapor", "muhasebe"],
   "Kasa & Giderler sayfası günlük ciroyu, ödeme türlerine göre (nakit/POS/kredi kartı) geliri ve tüm giderleri gösterir. Yakıt, kira, personel, malzeme gibi giderleri ekleyip raporlayabilirsiniz."],
  [["masa", "salon", "hesap kapat"],
   "Masalar & QR sayfasından masa ekleyin; her masanın kendi QR kodu vardır. Masaya sipariş eklenir, hesap kapatılırken ödeme yöntemi (nakit/POS/kredi kartı) seçilir ve kasaya işlenir."],
  [["yükle", "indir", "program", "uygulama", "apk"],
   "Siteyi bilgisayarınıza program gibi kurmak için ana sayfadaki 'İndir' bölümündeki 'Hemen Yükle' butonuna basın. Kurye ve Caller ID Android uygulamalarını paneldeki ilgili sayfalardan APK olarak indirebilirsiniz."],
  [["kullanıcı numarası", "id", "numaram"],
   "Hesabınıza özel 6 haneli kullanıcı numaranızı panelin Hesap Ayarları sayfasında görebilirsiniz. Destek taleplerinde bu numarayı paylaşmanız yeterlidir."],
  [["lisans", "aktivasyon", "süre"],
   `Yıllık lisans ve platform aktivasyonları destek hattımızdan açılır. Lisansınızın durumunu panelin üst kısmında görebilirsiniz. Aktivasyon için ${SUPPORT_PHONE} numarasını arayın veya WhatsApp'tan yazın.`],
  [["destek", "yardım", "iletişim", "telefon", "whatsapp"],
   `Bize her zaman ulaşabilirsiniz: Telefon ${SUPPORT_PHONE} veya WhatsApp üzerinden yazın. Çalışma saatleri içinde hızlı dönüş yapıyoruz.`],
];

const GREETING = "Merhaba! Ben Gazi Sepet yardımcı asistanıyım. Kayıt, QR menü, kurye, yazıcı, platform entegrasyonları, kasa veya fiyat hakkında sorularınızı yanıtlarım.";

function answer(q) {
  const s = q.toLowerCase();
  let best = null, bestScore = 0;
  for (const [keys, resp] of KB) {
    const score = keys.reduce((acc, k) => acc + (s.includes(k) ? k.length : 0), 0);
    if (score > bestScore) { bestScore = score; best = resp; }
  }
  if (best) return best;
  return `Bunu tam anlayamadım. Şu konularda yardımcı olabilirim: kayıt/giriş, QR menü ve paket sipariş, kurye takibi, Caller ID, yazıcı ve fiş, Trendyol/Yemeksepeti/Migros entegrasyonu, kasa ve fiyat. Ya da bize doğrudan ulaşın: ${SUPPORT_PHONE}.`;
}

export function HelpAssistant() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([{ from: "bot", text: GREETING }]);
  const [input, setInput] = useState("");
  const bodyRef = useRef(null);

  useEffect(() => { bodyRef.current?.scrollTo(0, bodyRef.current.scrollHeight); }, [msgs, open]);

  const send = () => {
    const q = input.trim();
    if (!q) return;
    setMsgs((m) => [...m, { from: "user", text: q }, { from: "bot", text: answer(q) }]);
    setInput("");
  };

  return (
    <>
      <button onClick={() => setOpen(!open)} data-testid="help-assistant-toggle"
        className="fixed bottom-5 right-5 z-50 h-14 w-14 rounded-full bg-[#FF6B0A] hover:bg-[#E55A00] text-white shadow-2xl grid place-items-center transition-transform hover:scale-110 active:scale-95">
        {open ? <X className="h-6 w-6" /> : <MessageCircleQuestion className="h-7 w-7" />}
      </button>
      {open && (
        <div className="fixed bottom-24 right-5 z-50 w-[92vw] max-w-sm rounded-3xl border bg-white shadow-2xl overflow-hidden flex flex-col" data-testid="help-assistant-panel" style={{ maxHeight: "70vh" }}>
          <div className="bg-[#0F1F45] text-white px-5 py-4 flex items-center gap-3">
            <Sparkles className="h-5 w-5 text-[#FF6B0A]" />
            <div><p className="font-display font-bold">Yardımcı Asistan</p><p className="text-xs text-white/60">Sorularınızı yazın, anında yanıtlayayım</p></div>
          </div>
          <div ref={bodyRef} className="flex-1 overflow-y-auto p-4 space-y-3" data-testid="help-assistant-messages">
            {msgs.map((m, i) => (
              <div key={i} className={`flex ${m.from === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`rounded-2xl px-4 py-2.5 text-sm max-w-[85%] leading-relaxed ${m.from === "user" ? "bg-[#FF6B0A] text-white" : "bg-slate-100 text-slate-800"}`}>{m.text}</div>
              </div>
            ))}
          </div>
          <div className="p-3 border-t flex gap-2">
            <input value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
              placeholder="Örn: QR kod ile nasıl sipariş alınır?" data-testid="help-assistant-input"
              className="flex-1 rounded-full border px-4 py-2.5 text-sm outline-none focus:border-[#FF6B0A]" />
            <button onClick={send} data-testid="help-assistant-send" className="h-11 w-11 rounded-full bg-[#FF6B0A] hover:bg-[#E55A00] text-white grid place-items-center shrink-0"><Send className="h-4 w-4" /></button>
          </div>
          <div className="px-4 pb-3 flex gap-2 text-xs">
            <a href={SUPPORT_WA} target="_blank" rel="noreferrer" className="text-[#25D366] font-semibold" data-testid="help-assistant-wa">WhatsApp</a>
            <a href={SUPPORT_TEL} className="text-[#FF6B0A] font-semibold" data-testid="help-assistant-call">{SUPPORT_PHONE}</a>
          </div>
        </div>
      )}
    </>
  );
}
